import { render, staticRenderFns } from "./editPassword.vue?vue&type=template&id=227b46d6&scoped=true"
import script from "./editPassword.vue?vue&type=script&lang=js"
export * from "./editPassword.vue?vue&type=script&lang=js"
import style0 from "./editPassword.vue?vue&type=style&index=0&id=227b46d6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "227b46d6",
  null
  
)

export default component.exports